module.exports = __webpack_public_path__ + "img/zyxel.edfa1c56.png";